import { Ship, Waves, Anchor } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { DiaMareInterpretado } from '@/types/mare';

interface DiaPrincipalCardProps {
  dia: DiaMareInterpretado;
  t: (key: string) => string;
}

export function DiaPrincipalCard({ dia, t }: DiaPrincipalCardProps) {
  const titleKey =
    dia.interpretacao === 'maré-alta'
      ? 'widget.mare.principalAltaTitle'
      : dia.interpretacao === 'maré-média'
        ? 'widget.mare.principalMediaTitle'
        : 'widget.mare.principalBaixaTitle';

  const descKey =
    dia.interpretacao === 'maré-alta'
      ? 'widget.mare.principalAltaDesc'
      : dia.interpretacao === 'maré-média'
        ? 'widget.mare.principalMediaDesc'
        : 'widget.mare.principalBaixaDesc';

  return (
    <div className="bg-gradient-to-r from-ocean-50 to-teal-50 rounded-xl p-4 border border-ocean-100/50">
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0',
            dia.interpretacao === 'maré-alta'
              ? 'bg-coral/10'
              : dia.interpretacao === 'maré-média'
                ? 'bg-amber-100'
                : 'bg-teal-100'
          )}
        >
          {dia.interpretacao === 'maré-alta' ? (
            <Ship className="w-5 h-5 text-coral" />
          ) : dia.interpretacao === 'maré-média' ? (
            <Waves className="w-5 h-5 text-amber-600" />
          ) : (
            <Anchor className="w-5 h-5 text-teal-600" />
          )}
        </div>
        <div>
          <p className="font-display text-sm text-warm-dark">{t(titleKey)}</p>
          <p className="font-body text-xs text-warm-gray mt-0.5">{t(descKey)}</p>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2">
        <span className="text-lg" aria-label={dia.label} title={dia.label}>
          {dia.badge}
        </span>
        <span className="font-body text-sm font-medium text-warm-dark">{dia.label}</span>
        <span className="font-body text-xs text-warm-gray ml-auto">
          coef. {dia.coeficiente}
        </span>
      </div>
    </div>
  );
}
